import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Cook {
    KitchenName: string;
    genderName: string;
    mobile: any;
    data: any;
    status: any;
    firstName: any,
    lastName: any,
    dob: any,
    genderId: any,
    phone: any,
    email: any,
    profileImageUrl: string,
    auditTrailId: any,
    isActive: boolean,
    id: any
}

interface OrderCountCook {
    totalQty: number;
    totalSpent: number;
    cookProfileId: number;
    totalOrders: number;

}
interface CooksState {
    data: Cook[];
    cookData: Cook | null;
    loading: boolean;
    error: string | null;
    orderCount: OrderCountCook | null; 

}
const FOODURL = import.meta.env.VITE_API_FOOD_ORDER_URL;
const FOODPORT = import.meta.env.VITE_FOOD_ORDER_PORT;

const COOKPORT = import.meta.env.VITE_COOK_PORT;
const COOKURL = import.meta.env.VITE_API_COOK_URL;

const USERSPORT = import.meta.env.VITE_USERS_PORT;
const USERSURL = import.meta.env.VITE_API_USERS_URL;

// Diet Mapping Code
export const fetchCooks = createAsyncThunk<Cook[], void, { rejectValue: string }>(
    'Cooks/fetchCooks',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Cook[] }>('/get_all_cook', USERSPORT, USERSURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createCook = createAsyncThunk<Cook, any, { rejectValue: string }>(
    'Cooks/createCook',
    async (params, { rejectWithValue }) => {
        console.log('params :>> ', params);

        try {
            const response = await apiService.post<{ data: Cook }>('create_cook', params, COOKPORT, COOKURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateUser = createAsyncThunk<Cook, any, { rejectValue: string }>(
    'Cooks/updateUser',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Cook }>('update_user', params, COOKPORT, COOKURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

// Allergence Mapping Code


export const fetchAllergencePreferences = createAsyncThunk<Cook[], void, { rejectValue: string }>(
    'Cook/fetchAllergencePreferences',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Cook[] }>('/get_all_user_profile', COOKPORT, COOKURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createAllergencePreferences = createAsyncThunk<Cook, any, { rejectValue: string }>(
    'Cook/createAllergencePreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Cook }>('create_customer_allergen_map', params, COOKPORT, COOKURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateAllergencePreferences = createAsyncThunk<Cook, any, { rejectValue: string }>(
    'Cook/updateAllergencePreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Cook }>('update_spice_level', params, COOKPORT, COOKURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const getByIdCook = createAsyncThunk<
    Cook,
    { userProfileId: number | string },
    { rejectValue: string }
>(

    'Cook/getByIdCook',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>('get_by_id_cook', USERSPORT, USERSURL, config);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);



export const getByIdCookOrdersCount = createAsyncThunk<
    any, // ✅ Returned response type
    { cookProfileId: string | number }, // ✅ Argument type
    { rejectValue: string } // ✅ ThunkAPI config
>(
    'CookOrders/getByIdCookOrdersCount',
    async ({ cookProfileId }, { rejectWithValue }) => {
        try {
            const config = { params: { cookProfileId } };
            const response = await apiService.get<any>(
                'get_order_count',
                FOODPORT,
                FOODURL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);



export const CookSlice = createSlice({
    name: 'Cooks',
    initialState: {
        data: [],
        cookData: null,
        orderCount: null,
        loading: false,
        error: null,
    } as CooksState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchCooks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCooks.fulfilled, (state, action: PayloadAction<Cook[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCooks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createCook.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCook.fulfilled, (state, action: any) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createCook.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateUser.fulfilled, (state, action: PayloadAction<Cook>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(getByIdCook.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getByIdCook.fulfilled, (state, action: PayloadAction<Cook>) => {
                state.loading = false;
                state.cookData = action.payload;
            })
            .addCase(getByIdCook.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })


            // orderCount 

            .addCase(getByIdCookOrdersCount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getByIdCookOrdersCount.fulfilled, (state, action: PayloadAction<OrderCountCook>) => {
                state.loading = false;
                state.orderCount = action.payload;
            })
            .addCase(getByIdCookOrdersCount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default CookSlice.reducer;